module.exports = __webpack_public_path__ + "img/banner-credit01.eb88c53c.jpg";